import {ValueObject} from '@s-ui/domain'

import {TransactionError} from '../Errors/TransactionError.js'

export class InitReservationPaymentRequest extends ValueObject {
  /**
   * @param {String} reservationId
   * @param {Boolean} includeTermsAndConditions
   **/
  #reservationId
  #includeTermsAndConditions

  constructor({reservationId, includeTermsAndConditions}) {
    super()
    this.#reservationId = reservationId
    this.#includeTermsAndConditions = includeTermsAndConditions
  }

  getReservationId() {
    return this.#reservationId
  }

  getIncludeTermsAndConditions() {
    return this.#includeTermsAndConditions
  }

  get value() {
    return {reservationId: this.#reservationId, includeTermsAndConditions: this.#includeTermsAndConditions}
  }

  static validate({reservationId}) {
    const getInvalidParam = param => param === undefined || param === null || param === ''
    if (getInvalidParam(reservationId)) throw new TransactionError('Invalid InitReservationPaymentRequest')
  }

  static create({reservationId, includeTermsAndConditions}) {
    InitReservationPaymentRequest.validate({
      reservationId
    })
    return new InitReservationPaymentRequest({reservationId, includeTermsAndConditions})
  }
}
